import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import MainLayout from './partials/MainLayout';
import MainBodyLayout from './partials/MainBodyLayout';
import { useSetting } from '../../../../utilities/sharedHooks/settings';

export const PaymentBannerInfo = () => {
  const { t: translate } = useTranslation();

  const [settings] = useSetting('content_urls', [
    'content_url_change_your_default_contactless_payment_method_google_pay',
    'content_url_learn_how_to_verify_your_payment_method_google_pay',
  ]);

  const {
    content_url_change_your_default_contactless_payment_method_google_pay:
      googleSupportSetupCardUrl,
    content_url_learn_how_to_verify_your_payment_method_google_pay: googleSupportVerifyUrl,
  } = settings || {
    content_url_change_your_default_contactless_payment_method_google_pay: '',
    content_url_learn_how_to_verify_your_payment_method_google_pay: '',
  };

  return (
    <MainLayout>
      <MainBodyLayout
        className="payment-banner-container"
        withBack
        title={translate('payment_banner_info_title')}>
        <div className={`position-relative info mt-4 ${isMobile && 'info-mobile'}`}>
          <img
            className="info-image rounded-extra"
            src="./assets/images/payment-banner-info.png"
            alt="plus"
          />
        </div>
        <div className="d-flex flex-column mt-4 pt-3">
          <p className="text-f5 text-bold text-dark text">
            {translate('payment_banner_info_apple')}
          </p>
          <p className="text-f5 text-dark text mt-3">
            {translate('payment_banner_info_steps_apple_title')}
          </p>
          <ul className="list mt-4 ps-4">
            <li className="text">{translate(`payment_banner_info_apple_step_1`)}</li>
            <ul className="sub-list">
              <li className="text">{translate('payment_banner_info_apple_step_1_1')}</li>
              <li className="text">{translate('payment_banner_info_apple_step_1_2')}</li>
            </ul>
            <li className="text mt-2">{translate(`payment_banner_info_apple_step_2`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_apple_step_3`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_apple_step_4`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_apple_step_5`)}</li>
          </ul>
          <p className="text-f5 text-bold text-dark text mt-4">
            {translate('payment_banner_info_google')}
          </p>
          <p className="mt-3">
            <Trans
              i18nKey="payment_banner_info_steps_google_title"
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
                <a
                  key="contact-link-3"
                  className=" text-decoration-none"
                  href={googleSupportSetupCardUrl}
                  target="_blank"
                  rel="noreferrer"
                />,
              ]}
            />
          </p>
          <ul className="list mt-4 ps-4">
            <li className="text">{translate(`payment_banner_info_google_step_1`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_google_step_2`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_google_step_3`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_google_step_4`)}</li>
            <li className="text mt-2">{translate(`payment_banner_info_google_step_5`)}</li>
            <li className="text mt-2">
              <Trans
                className="mt-5"
                i18nKey="payment_banner_info_google_step_6"
                components={[
                  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
                  <a
                    key="contact-link-3"
                    className=" text-decoration-none"
                    href={googleSupportVerifyUrl}
                    target="_blank"
                    rel="noreferrer"
                  />,
                ]}
              />
            </li>
            <li className="text mt-2">{translate(`payment_banner_info_google_step_7`)}</li>
          </ul>
        </div>
      </MainBodyLayout>
    </MainLayout>
  );
};

export default PaymentBannerInfo;
